import Vue from 'vue'
import Vuex from 'vuex'
import { getAppConfig } from '@/api/config'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    position: [],
  },
  getters: {
    position: state => state.position,
  },
  mutations: {
    SET_POSITION: (state, position) => {
      state.position = position
    },
  },
  actions: {
    setPosition({ commit }, position) {
      commit('SET_POSITION', position)
    }
  },
  modules: {
  }
})
